import useStore from '../../../storeZustand';

export const useBasketItem = () => {
  const { decreaseQuantity, increaseQuantity, removeItem, setQuantity } = useStore();
  return { decreaseQuantity, increaseQuantity, removeItem, setQuantity };
};
